import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EnrichmentGuidePOI } from 'src/app/Models/enrichment-guide-poi';

@Component({
  selector: 'app-poi-item',
  templateUrl: './poi-item.component.html',
  styleUrls: ['./poi-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoiItemComponent {
  @Input() poi!: EnrichmentGuidePOI;
  @Input() showDistance = true;

  expanded = false;
}
